import { type StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import { ColoredBulletsProsAndCons } from './ColoredBullets';
import { DefaultProsAndCons } from './Default';
import { PanelProsAndCons } from './Panel';

type Props = {
  prosList?: string[] | StructuredContentDocument[];
  consList?: string[] | StructuredContentDocument[];
  variant?: 'default' | 'colored-bullets' | 'panel';
};

export function ProsAndCons({ prosList, consList, variant = 'default' }: Props) {
  if (variant === 'panel') {
    return <PanelProsAndCons prosList={prosList} consList={consList} />;
  }

  if (variant === 'colored-bullets') {
    return <ColoredBulletsProsAndCons prosList={prosList} consList={consList} />;
  }

  return <DefaultProsAndCons prosList={prosList} consList={consList} />;
}
